<div class="loader" *ngIf="loader.showSpinner | async">
</div>